module.exports = __webpack_public_path__ + "img/40-image-1@2x.2851ad26.png";